
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/feeds/about-promise",
      function () {
        return require("private-next-pages/content/feeds/about-promise.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/feeds/about-promise"])
      });
    }
  